<template>
  <div class="results">
    <div class="results-card" v-for="items in data" :key="items.id">
      <div class="results-card-title">
        <span
          v-if="
            items._source['metatag.og:title'] === undefined &&
              items._source.title !== undefined
          "
        >
          <a :href="items._source.url.href">{{ items._source.title }}</a>
        </span>
        <span v-else-if="items._source['metatag.og:title'] !== undefined">
          <a :href="items._source.url">{{
            items._source["metatag.og:title"]
          }}</a>
        </span>
        <span v-else
          ><a :href="items._source.url">{{ items._source.url }}</a></span
        >
      </div>
      <div class="results-card-description">
        <p
          v-if="
            items._source['metatag.og:description'] !== undefined ||
              items._source['metatag.description'] !== undefined ||
              items._source['description'] !== undefined ||
              items._source['dcterms.description'] !== undefined
          "
        >
          <span v-if="items._source['metatag.og:description']">
            {{ items._source["metatag.og:description"] }}
          </span>
          <span v-else-if="items._source['metatag.description']">
            {{ items._source["metatag.description"] }}
          </span>
          <span v-else-if="items._source.description">
            {{ items._source.description }}
          </span>
          <span v-else-if="items._source['dcterms.description']">
            {{ items._source["dcterms.description"] }}
          </span>
        </p>
        <p v-else>
          {{ items._source.content | truncate(300) }}
        </p>
      </div>
      <div class="results-card-url">
        <a :href="items._source.url.href">{{ items._source.url.href }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoSearchResults",
  data() {
    return {};
  },
  props: {
    results: Array
  },
  computed: {
    data() {
      let data = this.results;
      for (let i in data) {
        data[i]._source.url = new URL(data[i]._source.url);
        data[i]._source.url.protocol = "https";
      }
      return data;
    }
  }
};
</script>

<style lang="scss" scoped>
.results {
  &-card {
    margin: 1em 0;
    &-url {
      a {
        color: darken($green, 10%);
      }
    }
  }
}
</style>
